import React from 'react';
import { TbClockHour8 } from "react-icons/tb";
import { formatISODate, formatISOTime } from "../utils/DateTimeUtills";
import useMyTranslation from "../Hooks/useMyTranslation";
import { Badge, OverlayTrigger, Popover } from "react-bootstrap";
import ConditionalRender from "./ConditionalRender";

export default function MsisdnOverviewRow({ overview, showGeofenceStatus = true, msisdnStatusPlacement = 'top', onMsisdnToSendMessageSelected }) {
    const typeNotWorking = 'notWorking';
    const typeWorking = 'working';
    const typeFinishedWorking = 'finishedWorking';

    //Reload every 1 minute
    // const [time, setTime] = useState(Date.now());
    // const {t} = useTranslation()

    // useEffect(() => {
    //     const interval = setInterval(() => setTime(Date.now()), 60_000);
    //
    //     //Clear on un-mount to avoid memory leaks
    //     return () => {
    //         clearInterval(interval);
    //     };
    // }, []);


    // const lastTimeOnline = overview.telemetry ? new Date(overview.telemetry.timestamp) : undefined;
    // const minutesPassed = differenceInSeconds(lastTimeOnline) / 60;
    // const onlineStatusThresholdMin = 7
    //
    // const getOverlay = (geofenceInfo) => {
    //     return (
    //         <Popover id="popover-basic">
    //             <Popover.Body>
    //                 <div className={'center-h'}>
    //                     <span>{formatISO8601Short(geofenceInfo.from)}</span>
    //                     <ConditionalRender condition={geofenceInfo.isInside === false}>
    //                         <span className={'mx-2'}>-</span>
    //                         <span>{formatISO8601Short(geofenceInfo.to)}</span>
    //                     </ConditionalRender>
    //                 </div>
    //
    //                 <hr className={'my-2'}/>
    //                 <ConditionalRender condition={geofenceInfo.assignedWorkOrders.length > 0}
    //                                    fallback={<small className={'small-text'}>{t('pages.dashboard.noWorkOrdersAssigned')}</small>}>
    //                     <div className={'d-flex flex-column justify-content-center'}>
    //                         {geofenceInfo.assignedWorkOrders.map((workOrder, i) =>
    //                             <Badge key={workOrder.key} bg={'primary'} className={'my-1 w-100'}><span className={'text-truncate'}>{workOrder.name} ({workOrder.key})</span></Badge>
    //                         )}
    //                     </div>
    //                 </ConditionalRender>
    //             </Popover.Body>
    //         </Popover>
    //     )
    // }

    const t = useMyTranslation('pages.dashboard')

    const Indicator = () => {

        const baseDot = {
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            display: 'inline-block',
            minWidth: '12px',
        }

        let dotStyle = {
            ...baseDot,
        };

        let type = typeNotWorking;

        if ((overview.geofences.active.length > 0 || overview.geofences.recent.length > 0 || overview.workday.start?.determination === 'Event') && overview.workday.end?.determination !== 'Event') {
            type = typeWorking;
        }
        else if (overview.workday.end?.determination === 'Event') {
            type = typeFinishedWorking
        }

        if (type === typeNotWorking) {
            dotStyle = {
                ...dotStyle,
                border: '1px solid #585858'
            }
        }

        if (type === typeWorking) {
            dotStyle = {
                ...dotStyle,
                backgroundColor: 'green'
            }
        }

        if (type === typeFinishedWorking) {
            dotStyle = {
                ...dotStyle,
                backgroundColor: 'gray'
            }
        }


        // if(!overview.hasEventsToday && overview.geofences.active.length < 1 && overview.geofences.recent.length < 1) {
        //   dotStyle = {
        //       ...dotStyle,
        //       border: '1px solid #585858'
        //   }
        // }
        //
        // if((overview.geofences.active.length > 0 || overview.geofences.recent.length > 0 || overview.workday.start?.determination === 'Event') && overview.workday.end?.determination !== 'Event')
        // {
        //     dotStyle = {
        //         ...dotStyle,
        //         backgroundColor: 'green'
        //     }
        // }
        //
        // if (overview.workday.end?.determination === 'Event')
        // {
        //     dotStyle = {
        //         ...dotStyle,
        //         backgroundColor: 'gray'
        //     }
        // }

        return (
            <OverlayTrigger overlay={getOverlay(type)}>
                <i style={dotStyle} />
            </OverlayTrigger>
        )
    }

    const getOverlay = (type) => {

        return (
            <Popover id="popover-basic" style={{ cursor: 'default' }}>
                <Popover.Body className={'p-2'}>
                    {labelForType(type)}
                </Popover.Body>
            </Popover>
        )
    }

    const labelForType = (type) => {
        if (type === typeNotWorking)
            return t('workdayStatus.notWorking')
        if (type === typeWorking)
            return t('workdayStatus.working')
        if (type === typeFinishedWorking)
            return t('workdayStatus.finished')
    }

    const WorkdayEventTime = ({ workdayPart }) => {
        if (!workdayPart || workdayPart.determination === 'Geofence')
            return <span>-</span>

        return (
            <div className={'d-flex align-items-center'}>
                <TbClockHour8 />
                <span className={'ps-1'}>{formatISODate(workdayPart.time, {
                    format: 'timeOnly',
                    useLocalTime: true
                })}</span>
            </div>
        )
    }

    const FinishedGeofenceTransactionStatus = ({ transaction, geofence }) => {

        const geofenceWrapperStyle = {
            border: '1px solid gainsboro',
            padding: '1px 3px',
        }

        return (
            <div className={'d-flex px-2 py-1'}>
                <div>
                    <span
                        className={'small tabular rounded-5 p-1 px-2 bg-success text-white fw-bold'} style={{ fontSize: 12 }}>{formatISOTime(transaction.from)}</span>
                    <span className={''}> — </span>
                    <span
                        className={'small tabular rounded-5 p-1 px-2 bg-secondary text-white fw-bold'} style={{ fontSize: 12 }}>{formatISOTime(transaction.to)}</span>
                </div>
                <div className={'ms-2 ps-2 d-flex align-items-center rounded-5'} style={geofenceWrapperStyle}>
                    <span className={'me-1'}>{geofence.name}</span>
                    <ConditionalRender condition={geofence.key}>
                        <Badge pill bg={'light'} className={'border border-secondary-subtle'}><small className={'text-dark'}>{geofence.key}</small></Badge>
                    </ConditionalRender>
                </div>


            </div>
        )
    }

    const ActiveGeofenceTransactionStatus = ({ geofence }) => {
        return (
            <div className={'d-flex align-items-center my-1'}>
                <div className={'d-flex align-items-center border border-success rounded-5 py-1 ps-2 pe-1 me-2'} style={{ minWidth: 0 }}>
                    <i style={{
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        display: 'inline-block',
                        backgroundColor: 'green',
                        marginRight: 5,
                        flexShrink: 0
                    }} />

                    <span style={{ flexShrink: 0 }}>{formatISOTime(geofence.since)}</span>

                    <div className={'ps-3 d-flex align-items-center rounded-5'} style={{ minWidth: 0 }}>
                        <span className={'me-1'} style={{ overflowWrap: 'anywhere' }}>{geofence.name}</span>
                        <ConditionalRender condition={geofence.key}>
                            <Badge pill bg={'light'} className={'border border-secondary-subtle'}><small className={'text-dark'}>{geofence.key}</small></Badge>
                        </ConditionalRender>

                    </div>
                </div>


            </div>
        )
    }

    return (
        overview && (
            <tr>
                <td className="align-top" style={{ paddingLeft: "0.7rem" }}>
                    <Indicator />
                </td>
                <td className="text-start align-top">
                    <span>{overview.msisdn.fullName}</span>
                </td>

                <td className="align-top">
                    <span>{overview.msisdn.id}</span>
                </td>

                <td className="align-top">
                    <WorkdayEventTime workdayPart={overview.workday?.start} />
                </td>

                <td className="align-top">
                    <WorkdayEventTime workdayPart={overview.workday?.end} />
                </td>
                <td className="align-top">
                    <div className={'d-flex flex-column'}>
                        {(overview?.geofences?.active ?? [])
                            .flatMap(geofence => {
                                // If geofence has transactions, return them
                                if (Array.isArray(geofence.transactions) && geofence.transactions.length > 0) {
                                    return geofence.transactions.map(transaction => ({
                                        ...transaction,
                                        geofence,
                                    }));
                                }
                                // Otherwise return the geofence itself (so we still show it)
                                return [{ geofence }];
                            })
                            .sort((a, b) => new Date(a.from ?? a.geofence?.since) - new Date(b.from ?? b.geofence?.since))
                            .map(geofence => (
                                <>
                                    {/*<div key={index} className={'d-flex align-items-center'}>*/}
                                    {/*    <i style={{*/}
                                    {/*        width: 12,*/}
                                    {/*        height: 12,*/}
                                    {/*        borderRadius: '50%',*/}
                                    {/*        display: 'inline-block',*/}
                                    {/*        backgroundColor: 'green',*/}
                                    {/*        marginRight: 5*/}
                                    {/*    }}/>*/}

                                    {/*    <span className={'d-inline-block'} style={{fontSize: 'smaller'}}>({formatISOTime(geofence.since)} - {t('now', 'global.time')})</span>*/}

                                    {/*    <span className={'ps-2'}>{geofence.name}</span>*/}
                                    {/*    {geofence.key && <span className={'ps-1'}>({geofence.key})</span>}*/}
                                    {/*</div>*/}

                                    {/*<ActiveGeofenceTransactionStatus geofence={geofence}/>*/}
                                    <ActiveGeofenceTransactionStatus key={`${geofence.geofence.id}-${geofence.id}`} geofence={geofence.geofence} />
                                </>
                            ))}
                    </div>
                </td>
                <td className="align-top">
                    <div className="d-flex flex-column">
                        {(overview?.geofences?.recent ?? [])
                            .flatMap(geofence =>
                                (geofence.transactions ?? []).map(transaction => ({
                                    ...transaction,
                                    geofence,
                                }))
                            )
                            .sort((a, b) => new Date(a.from) - new Date(b.from))
                            .map(transaction => (
                                <FinishedGeofenceTransactionStatus
                                    key={`${transaction.geofence.id}-${transaction.id}`}
                                    transaction={transaction}
                                    geofence={transaction.geofence}
                                />
                            ))}
                    </div>
                </td>
            </tr>
        )
    );



    // return (
    //     overview &&
    //     <tr>
    //         <td>
    //             <span>{overview.msisdn.id}</span>
    //         </td>
    //         <td>
    //             <span>{overview.msisdn.fullName ?? "-"}</span>
    //         </td>
    //         <td>
    //             <ConditionalRender condition={overview.msisdn.note} fallback={<span>-</span>}>
    //                 <InfoIcon className='ms-1' iconOptions={{icon: faNoteSticky, color: 'rgb(255 169 42)'}} text={overview.msisdn.note} />
    //             </ConditionalRender>
    //         </td>
    //         <td>
    //             <div>
    //                 <StatusComponent telemetry={overview.telemetry} active={minutesPassed < onlineStatusThresholdMin} placement={msisdnStatusPlacement}/>
    //             </div>
    //         </td>
    //         {
    //             showGeofenceStatus &&
    //             <td>
    //                 <ConditionalRender condition={overview.insideGeofences.length > 0} fallback={<Badge bg={'secondary'}>{t('pages.dashboard.statusBadge.out')}</Badge>}>
    //                     <div className={'d-flex flex-wrap justify-content-start'} style={{maxHeight: 100, cursor: 'default', scrollbarWidth: "none"}}>
    //                         {overview.insideGeofences.map((geofence, i) =>
    //                             <OverlayTrigger getOverlay={getOverlay(geofence)} key={i} placement={'bottom'}>
    //                                 <Badge bg={geofence.isInside ? 'success' : 'warning'} className={'m-1'}>{geofence.geofenceName}</Badge>
    //                             </OverlayTrigger>
    //                         )}
    //                     </div>
    //                 </ConditionalRender>
    //                 {/*{badgeForStatus(overview.insideGeofences, overview.scheduledGeofences.length > 0)}*/}
    //             </td>
    //         }
    //         <td>
    //             <div>
    //             <ClaimGuard requiredClaim={SEND_FCM_NOTIFICATION}>
    //                     <IconButton icon={faEnvelope} color='--dark-yellow' onClick={(e) => {
    //                         // setMessageBoxShown(true)
    //                         onMsisdnToSendMessageSelected(overview.msisdn)
    //                     }}/>
    //                 </ClaimGuard>
    //                 {/*{*/}
    //                 {/*    overview.lastLocation &&*/}
    //                 {/*    <OverlayTrigger*/}
    //                 {/*        placement="top"*/}
    //                 {/*        delay={{ show: 300, hide: 100  }}*/}
    //                 {/*        getOverlay={<Tooltip id="button-tooltip-2">{formatDateTime(new Date(overview.lastLocation.timestamp))} </Tooltip>}*/}
    //                 {/*    >*/}
    //                 {/*        <IconButton icon={faLocationDot} color={differenceInMinutes(new Date(overview.lastLocation.timestamp)) < 90 ? 'red' : 'gray' } onClick={() => {*/}
    //                 {/*            if(hasClaim(Claims.REQ_LOCATION_UPDATE))*/}
    //                 {/*            {*/}
    //                 {/*                requestLocationUpdate(overview.msisdn.id)*/}
    //                 {/*            }*/}
    //                 {/*            const location = `${overview.lastLocation.latitude},${overview.lastLocation.longitude}`;*/}
    //                 {/*            const zoomLevel = 14;*/}
    //
    //                 {/*            const googleMapsUrl = `https://www.google.com/maps?q=${location}&ll=${location}&z=${zoomLevel}`;*/}
    //
    //                 {/*            // Open the URL in a new tab*/}
    //                 {/*            window.open(googleMapsUrl, "_blank");*/}
    //                 {/*        }}/>*/}
    //                 {/*    </OverlayTrigger>*/}
    //                 {/*}*/}
    //             </div>
    //         </td>
    //     </tr>
    // )
}